import { Injectable } from '@angular/core';
import { StyleDescription } from '../models/new/style-description';
import { Collection } from '../models/new/collection';

@Injectable({
	providedIn: 'root'
})
export class CollectionMapper {
	constructor() {}

	toCollection(collection: any) {
		return new Collection({
			id: collection.id,
			name: collection.name
		});
	}
}
